module.exports = __webpack_public_path__ + "img/azxy8_icon.04d238ad.png";